import { PropsWithChildren, FC, createContext, useState } from "react";
import HeaderBase from "../Header/HeaderBase";
import cx from "classnames";
import Tick from "../../assets/Tick.svg";

type Step = {
  id: number;
  label: string;
  isActive: boolean;
};

type NetworkContextValue = {
  steps: Step[];
  setActiveStep: (id: number) => void;
};
const initialNetworkSteps = [
  { id: 1, label: "Phrase", isActive: true },
  { id: 2, label: "Trust Experiment", isActive: false },
  { id: 3, label: "Mint", isActive: false }
];
export const NewtworkContext = createContext<NetworkContextValue | null>(null);

const Layout: FC<
  PropsWithChildren<{
    hideMenu?: boolean;
    hideWalletBtn?: boolean;
    showExitInsteadOfConnect?: boolean;
    middleElementClassName?: string;
  }>
> = ({
  children,
  hideMenu,
  showExitInsteadOfConnect,
  middleElementClassName,
  hideWalletBtn
}) => {
  const [steps, setSteps] = useState<Step[]>(initialNetworkSteps);

  const setActiveStep = (id: number) => {
    const newSteps = steps.map(step => {
      if (step.id === id) {
        return { ...step, isActive: true };
      }
      return { ...step, isActive: false };
    });
    setSteps(newSteps);
  };

  const getActiveStepId = () => {
    const item = Object.values(steps).find(step => step.isActive);
    return item?.id ?? 0;
  };

  return (
    <NewtworkContext.Provider value={{ steps, setActiveStep }}>
      <HeaderBase
        hideMintBtn={true}
        showMobileMenu={false}
        showExitInsteadOfConnect={showExitInsteadOfConnect}
        hideWalletBtn={hideWalletBtn}
        transparentHeader
        childClassName={middleElementClassName}>
        {!hideMenu && (
          <div className="flex gap-8 text-coinage-body pt-6 tab:pt-0 w-full justify-center">
            {steps.map(step => {
              const isPastStep = step.id < getActiveStepId();
              const className = cx("justify-center items-center gap-2", {
                "hidden tab:flex": !step.isActive,
                flex: step.isActive
              });
              return (
                <p key={step.id} className={className}>
                  <span
                    className={cx(
                      {
                        "bg-coinage-orange text-coinage-offWhite border-coinage-orange":
                          step.isActive,
                        "border-current": !step.isActive,
                        "text-coinage-blue border-coinage-blue": isPastStep
                      },
                      "flex items-center justify-center rounded-full w-7 h-7 border-2 mono1"
                    )}>
                    {isPastStep ? <Tick width="15" /> : step.id}
                  </span>
                  <span
                    className={cx("btn", {
                      "text-coinage-orange": step.isActive,
                      "text-coinage-blue": isPastStep
                    })}>
                    {step.label}
                  </span>
                </p>
              );
            })}
          </div>
        )}
      </HeaderBase>
      <main>{children}</main>
    </NewtworkContext.Provider>
  );
};

export default Layout;
